'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _projects = require('helpers/projects');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AlbumThumbDescrition.scss');

var AlbumThumbDescrition = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumThumbDescrition, _PureComponent);

  function AlbumThumbDescrition() {
    (0, _classCallCheck3.default)(this, AlbumThumbDescrition);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumThumbDescrition.__proto__ || (0, _getPrototypeOf2.default)(AlbumThumbDescrition)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumThumbDescrition, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album;

      var isQS = album.projectContentType === _projects.projectTypes.quickSend || album.projectType === _projects.projectTypes.quickSend;
      var t = this.context.t;


      if (album.imageThumb) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.description, { isQS: isQS }) },
        isQS ? t('Quick Send') : t('No image available')
      );
    }
  }]);
  return AlbumThumbDescrition;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = AlbumThumbDescrition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumThumbDescrition/AlbumThumbDescrition.js
// module id = 511
// module chunks = 1